import Graphic from "@arcgis/core/Graphic";
import * as symbolUtils from "@arcgis/core/symbols/support/symbolUtils.js";
import { useEffect, useState } from "react";
import CloseIcon from "../../../assets/close.svg?react";
import LighthouseIcon from "../../../assets/lighthouse.svg?react";
import "./OverettObject.css";

interface OverettObjectProps {
    object: Graphic | null | undefined;
    onRemove?: () => void;
}

const OverettObject = (props: OverettObjectProps) => {
    const { object, onRemove } = props;

    const [symbolHtmlElement, setSymbolHtmlElement] = useState<HTMLElement | null | undefined>(null);

    useEffect(() => {
        if (!object) return;

        symbolUtils.getDisplayedSymbol(object).then((symbol) => {
            if (symbol) {
                symbolUtils.renderPreviewHTML(symbol, { size: 12 }).then((symbolElement) => {
                    setSymbolHtmlElement(symbolElement);
                });
            }
        });
    }, [object]);

    return object === undefined ? (
        <div>Ingen.</div>
    ) : (
        <div className="overett-object">
            <div className="small-gap">
                {symbolHtmlElement ? (
                    <div dangerouslySetInnerHTML={{ __html: symbolHtmlElement?.outerHTML ?? "" }}></div>
                ) : (
                    <LighthouseIcon />
                )}
                <span>{object?.attributes.navn ?? ""}</span>
            </div>
            {onRemove && (
                <button className="empty-button" onClick={onRemove}>
                    <CloseIcon />
                </button>
            )}
        </div>
    );
};

export default OverettObject;
